import React from 'react';

import { connect } from 'react-redux';
import { ImportFile } from 'components';
import { fromReservation, fromMarket } from 'store/selectors';
import {
    setImportFile,
    updateImportedFile,
    resetImportFile,
    importFileChangeGuest,
    setCorrectColumnFromImportedFile,
    removeCorrectColumnFromImportedFile,
    saveRequest,
    setStepInProcessImportedFile,
    stepBackAndForthInProcessImportedFile,
    setActiveCabinForImportedFileCabinDistributor,
    setActivePersonForImportedFileCabinDistributor,
    removePersonFromPersonsLinkedToCabinImportedFile,
    addAnonymousIdAndCabinForImport,
  } from 'store/actions';

const ImportFileContainer = props => <ImportFile {...props} />;

const mapStateToProps = (state) => {
  const nationalities = fromMarket.getNationalities(state);
  const ages = fromMarket.getAges(state);
  const genders = fromMarket.getGenders(state);
  const guestIds = fromReservation.getGuestIds(state);
  const cabinsAllocated = fromReservation.isCabinsAllocated(state, fromReservation.getActiveDepartureId(state));
  const titleOnColumnNumber = fromReservation.getImportedFileTitleOnColumnNumber(state);
  const mandatoryBirthdate = fromReservation.isBirthDateMandatory(state);
  const cabindIds = fromReservation.getCabinIds(state);
  const importStepProcess = fromReservation.getImportedFileStepProcess(state);
  const importedFileActiveStep = fromReservation.getImportedFileActiveStep(state);
  const activeCabinInCabinDistributor = fromReservation.getActiveCabinInCabinDistributor(state);
  const activePersonInCabinDistributor = fromReservation.getActivePersonInCabinDistributor(state);
  const personsLinkedToCabin = fromReservation.getPersonLinkedToCabin(state);
  const getImportedFileData = fromReservation.getImportedFileData(state);
  const getDepartures = fromReservation.getDepartures(state);
  const cabinsOut = fromReservation.getCabinsByDeparture(state, getDepartures[0] || '');
  const cabinsHome = fromReservation.getCabinsByDeparture(state, getDepartures[1] || '');
  const routeNameOut = fromReservation.getDepartureRouteName(state, getDepartures[0] || '');
  const routeNameHome = fromReservation.getDepartureRouteName(state, getDepartures[1] || '');
  const reservationCode = fromReservation.getReservationCode(state);
  const isBirthDateMandatory = fromReservation.isBirthDateMandatory(state);
  const allRemainingCabinsIdsWithoutGuests = fromReservation.getAllRemainingCabinsIdsWithoutGuests(state);
  const getRemainingBeds = fromReservation.getRemainingBeds(state, activeCabinInCabinDistributor);
  let importedFileTitleRow = fromReservation.getImportedFileTitleRow(state);
  importedFileTitleRow = importedFileTitleRow.titleOnColumnNumber || [];
  // const listOfSaveStatus = guestIds.map(g => fromReservation.getGuestSaveStatus(state, g));
  return {
    reservationCode,
    nationalities,
    ages,
    genders,
    importedFileTitleRow,
    guestIds,
    cabinsAllocated,
    titleOnColumnNumber,
    mandatoryBirthdate,
    cabindIds,
    importStepProcess,
    importedFileActiveStep,
    cabinData: cabindIds.map(id => fromReservation.getCabin(state, id)),
    activeCabinInCabinDistributor,
    activePersonInCabinDistributor,
    personsLinkedToCabin,
    getImportedFileData,
    cabinsOut,
    cabinsHome,
    isBirthDateMandatory,
    allRemainingCabinsIdsWithoutGuests,
    routeNameOut,
    routeNameHome,
    getRemainingBeds,
  };
};

const mapDispatchToProps = dispatch => ({
  setImportFile: data => dispatch(setImportFile(data)),
  updateImportedFile: file => dispatch(updateImportedFile(file)),
  resetImportFile: () => dispatch(resetImportFile()),
  importFileChangeGuest: (guestId, resource, value) => dispatch(importFileChangeGuest(guestId, resource, value)),
  saveRequest: (id, resource) => dispatch(saveRequest(id, resource)),
  setCorrectColumnFromImportedFile: (column, title) => dispatch(setCorrectColumnFromImportedFile(column, title)),
  removeCorrectColumnFromImportedFile: column => dispatch(removeCorrectColumnFromImportedFile(column)),
  setStepInProcessImportedFile: steps => dispatch(setStepInProcessImportedFile(steps)),
  stepBackAndForthInProcessImportedFile: number => dispatch(stepBackAndForthInProcessImportedFile(number)),
  setActiveCabinForImportedFileCabinDistributor: id => dispatch(setActiveCabinForImportedFileCabinDistributor(id)),
  setActivePersonForImportedFileCabinDistributor: obj => dispatch(setActivePersonForImportedFileCabinDistributor(obj)),
  removePersonFromPersonsLinkedToCabinImportedFile: cabinId => dispatch(removePersonFromPersonsLinkedToCabinImportedFile(cabinId)),
  addAnonymousIdAndCabinForImport: obj => dispatch(addAnonymousIdAndCabinForImport(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportFileContainer);



// WEBPACK FOOTER //
// ./src/containers/ImportFile.js